import Config from "../config/settings";

export class Utils {
    
    public static selectRpcHost(rpcName: 'leoRPC' | 'constantK', isWebsocket: boolean = false): string {
        switch (rpcName) {
            case 'leoRPC':
                return Config.mainnetLeoRPC;

            case 'constantK':
                if (isWebsocket) {
                    if (Math.round(Math.random()) === 0) {
                        return Config.mainnetConstantK_WS_Us + Config.apiKeyConstantK;
                    } else {
                        return Config.mainnetConstantK_WS_Eu + Config.apiKeyConstantK;
                    }
                } else {
                    if (Math.round(Math.random()) === 0) {
                        return Config.mainnetConstantK_Us + Config.apiKeyConstantK;
                    } else {
                        return Config.mainnetConstantK_Eu + Config.apiKeyConstantK;
                    }
                }

            default:
                return Config.mainnetLeoRPC;
        }
    }
}